import React from 'react';
import ProductsListItem from '../products-list-item/ProductsListItem';
// styles
import styles from './products.module.scss';

interface IProps {
  activeProduct?: string;
  products: any;
  itemsPerRow?: number;
  isBundle?: boolean;
}

const Products: React.FC<IProps> = ({ products, activeProduct, itemsPerRow = 3, isBundle }) => {
  return (
    <div className={styles.products}>
      {products.map((product: any) => (
        <ProductsListItem
          key={product.id}
          product={product}
          isActive={activeProduct === product.id}
          isBundle={isBundle}
          itemsPerRow={itemsPerRow}
        />
      ))}
    </div>
  );
};
export default Products;
